import type { Matchday } from '@uefadigital/panenka';
import { MatchDayType } from '@uefadigital/panenka';
import dayjs from 'dayjs';

import type { MatchesCalendarTab } from '../store/types';
import { MatchesCalendarTabType } from '../store/types';

import type { Draw } from '@shared-types/draw.types';
import type { Match, MatchCalendarDate, Round } from '@shared-types/match.types';

export const customDateFormat = 'YYYY-MM-DDTHH:mm:ssZZ';

export const mapDateToTab = (date: MatchCalendarDate): MatchesCalendarTab => {
  const d = date.date ? dayjs(date.date) : null;

  return {
    id: d?.format('YYYY-MM-DD'),
    type: MatchesCalendarTabType.DATE,
    date: d?.toISOString(),
    numberOfMatches: date.numberOfMatches,
  };
};

export const mapDrawToDateTab = (draw: Draw): MatchesCalendarTab => {
  const d = draw.date || draw.day ? dayjs(draw.date ?? draw.day) : null;

  return {
    id: d?.format('YYYY-MM-DD'),
    type: MatchesCalendarTabType.DATE,
    date: d?.toISOString(),
    draw,
    round: draw.rounds?.at(0).round,
  };
};

export const mapRoundToTab = (round: Round, matchdays?: Matchday[]): MatchesCalendarTab => {
  let id = round.id;
  if (matchdays?.length) id += `-${matchdays.at(0).type === MatchDayType.FIRST_LEG ? '1' : '2'}`;
  const date = matchdays?.at(0)?.dateFrom ?? round.dateFrom;
  return {
    id,
    type: MatchesCalendarTabType.ROUND,
    date: date ? dayjs(date, customDateFormat).toISOString() : null,
    round,
    matchdays,
  };
};

export const mapMatchDayToTab = (matchday: Matchday, round: Round): MatchesCalendarTab => ({
  id: matchday.id,
  type: MatchesCalendarTabType.MATCHDAY,
  date: matchday.dateFrom ? dayjs(matchday.dateFrom, customDateFormat).toISOString() : null,
  matchdays: [matchday],
  round,
});

export const mapDrawToTab = (draw: Draw): MatchesCalendarTab => ({
  id: draw.id,
  type: MatchesCalendarTabType.DRAW,
  date: draw.date || draw.day ? dayjs(draw.date ?? draw.day).toISOString() : null,
  draw,
  round: draw.rounds?.at(0).round,
});

export const mapMatchToTab = (match: Match, numberOfMatches = 1): MatchesCalendarTab => {
  let d = match.kickOffTime.dateTime && dayjs(match.kickOffTime.dateTime, customDateFormat);
  if (!d?.isValid()) d = match.kickOffTime.date ? dayjs(match.kickOffTime.date) : null;
  if (!d?.isValid()) d = null;

  return {
    id: d?.format('YYYY-MM-DD'),
    type: MatchesCalendarTabType.DATE,
    date: d?.toISOString(),
    numberOfMatches,
  };
};
